import { connect } from 'react-redux';
import { getStationHistory } from 'store/reducers/stationHistory';
import RecentlyPlayedStationsCollection from './RecentlyPlayedStationsCollection';

const mapStateToProps = (state) => ({
  history: getStationHistory(state),
});

export default connect(mapStateToProps)(RecentlyPlayedStationsCollection);
